import { offCanvasOpen, offCanvasClose } from "./handlers/offcanvas-handler";

class BetterModal {
	constructor() {
		this.modals = document.querySelectorAll("[data-better-modal]");
		this.buttons = document.querySelectorAll("[data-bm-button]");
		this.modalTriggerElements = document.querySelectorAll("[data-bm-trigger]");
		this.body = document.querySelector("body");
		this.state = {
			isOpen: false,
			hasBeenOpened: false,
			windowWidthHasChanged: false,
		};
		this.events = {
			"init": new CustomEvent("bm-init", {
				detail: {},
				bubbles: true,
				cancelable: false,
			}),
			"bm-open": (modal, id) => {
				var bmOpen = new CustomEvent("bm-open", {
					bubbles: true,
					cancelable: true,
				});

				// if theres an id we can assume a desktop menu item was hovered
				if (id) {
					const matchedItem = modal.querySelector(`#${id}`);
					matchedItem.classList.add("bm-show-item");

					if (!this.state.hasBeenOpened || (this.state.windowWidthHasChanged && window.innerWidth > 1024)) {
						addCloseEventToElements(modal);
					}
				}
				modal.dispatchEvent(bmOpen);
				modal.focus();
				this.state.isOpen = true;
				this.state.hasBeenOpened = true;
			},
			"bm-close": (modal, id) => {
				var bmClose = new CustomEvent("bm-close", {
					bubbles: true,
					cancelable: false,
				});
				if (id) {
					// console.log("running the class remove");
					const subItems = modal.querySelectorAll(`.bm-show-item`);
					subItems.forEach((item) => {
						item.classList.remove("bm-show-item");
					});

					// subItems.classList.remove("bm-show-item");
					// matchedItem.classList.remove("bm-show-item");
				}
				this.state.isOpen = false;
				modal.dispatchEvent(bmClose);
			},
		};

		const addCloseEventToElements = (modal) => {
			const closeElements = [
				"main",
				".logo", //
				".top-row",
				".cta-container",
				".entry-content",
				".cc-sct",
				".wp-block-post-content",
				".wp-container-1",
				"#footer",
			];

			if (window.innerWidth > 1024) {
				closeElements.push(".menu-item-no-children a");
			}

			const closeEventHandler = () => {
				this.events["bm-close"](modal);
				if (document.querySelector(".item-active")) {
					document.querySelector(".item-active").classList.remove("item-active");
				}
			};

			closeElements.forEach((item) => {
				if (!item) return;
				// const el = document.querySelector(item);
				const el = document.querySelectorAll(item);
				if (!el && !el[0]) return;

				if (item.length > 1) {
					el.forEach((innerItem) => {
						if (innerItem.hasAttribute("data-bm-close")) return;
						innerItem.addEventListener("mouseenter", closeEventHandler);
						innerItem.setAttribute("data-bm-close", "");
					});
					return;
				}
				if (el[0].hasAttribute("data-bm-close")) return;
				el[0].addEventListener("mouseenter", closeEventHandler);
				el[0].setAttribute("data-bm-close", "");
			});

			// const menuCancelItems = document.querySelectorAll(".menu-item-no-children a");
			const menuCancelItems = document.querySelectorAll("[data-bm-close]");

			const checkWindow = () => {
				// if window is smaller than 1024px remove event from these menu items
				if (window.innerWidth < 1024) {
					// console.log(menuCancelItems);
					menuCancelItems.forEach((item) => {
						item.removeEventListener("mouseenter", closeEventHandler);
						item.removeAttribute("data-bm-close");
					});
					// console.log("remove event");
				}
				this.state.windowWidthHasChanged = true;
			};

			// add window resize event
			window.addEventListener("resize", function () {
				checkWindow();
			});
		};

		this.modalEvents = {};

		if (this.modals.length) {
			this.init();
		} else {
			console.log("No Better Modals Found");
		}
	}

	init() {
		function positionNavigationModal() {
			// const headerHeight = document.querySelector("#navbar").offsetHeight;
			const headerBottomPos = document.querySelector("#navbar").getBoundingClientRect().bottom;
			// get the window top position of the header
			const headerTop = document.querySelector("#navbar").getBoundingClientRect().top;

			let calculatedHeaderBottom = headerBottomPos;
			if (!document.querySelector(".admin-bar")) {
				calculatedHeaderBottom = headerBottomPos + headerTop;
			} else {
			}

			const navModal = document.querySelector("#navigation-modal");
			navModal.style.top = `${calculatedHeaderBottom}px`;

			// if the window size is smaller than 1024px than calculate the height of the modal
			if (window.innerWidth < 1024) {
				navModal.style.height = ` calc(100% - ${calculatedHeaderBottom}px)`;
			} else {
				navModal.style.height = `auto`;
			}
		}
		positionNavigationModal();

		// Modal Setup
		this.modals.forEach((modal) => {
			const modalCard = modal.querySelector("[data-bm-card]");

			// Safety checks to ensure proper function
			if (modal.id.length === 0) {
				throw {
					message: "Better Modal requires an ID to initialize",
					el: modal,
				};
			}

			if (modal.hasAttribute("data-bm-is-offcanvas")) {
				if (modal.getAttribute("data-bm-direction") === "center") {
					throw {
						message: "Better Modal is not compatible with off canvas and direction also being center",
						el: modal,
					};
				}
				this.body.setAttribute("data-bm-offcanvas", "");
			}
			// End safety checks

			// Register custom events for this modal
			this.registerModalEvent(modal, "bm-open", this.openModalEvent.bind(this));
			this.registerModalEvent(modal, "bm-close", this.closeModalEvent.bind(this));

			window.addEventListener("resize", () => {
				positionNavigationModal();
				if (window.innerWidth > 1024 && this.state.isOpen == true) {
					// close the modal
					this.events["bm-close"](modal);
					// remove all instances of the bm-active attribute from the document
					const activeButtons = document.querySelectorAll("[bm-active]");
					activeButtons.forEach((button) => {
						button.removeAttribute("bm-active");
					});
				}
			});

			// Background overlay for this modal
			this.addModalOverlay(modal);

			// Add aria labels
			modal.setAttribute("aria-modal", "true");
			modal.setAttribute("role", "dialog");
			modalCard.setAttribute("tabindex", "-1");
		});

		this.buttons.forEach((button) => {
			const buttonID = button.getAttribute("data-bm-button");
			let modalEl = null;
			let validButton = false;

			// Button Safety checks
			// Check for a valid id on button
			this.modals.forEach((modal) => {
				if (modal.id === buttonID) {
					validButton = true;
					modalEl = modal;
				}
			});

			// Throw message if valid button not found
			if (!validButton) {
				throw {
					message:
						"Better Modal has found a button that does not have a valid ID: Check the ID for this button",
					el: button,
				};
			}
			// End buttons safety checks

			button.setAttribute("aria-label", "Navigation Button");
			button.setAttribute("aria-controls", buttonID);

			button.addEventListener("click", () => {
				if (modalEl.hasAttribute("data-bm-is-open")) {
					button.removeAttribute("bm-active");
					this.events["bm-close"](modalEl);
				} else {
					this.events["bm-open"](modalEl);
					button.setAttribute("bm-active", "");
				}
			});
		});

		// get all of the top level menu items in #primary-navigation
		const primaryNavItems = document.querySelectorAll("#primary-navigation .menu-item");
		// add event listeners to each of the top level menu items
		primaryNavItems.forEach((item) => {
			item.addEventListener("mouseenter", (e) => {
				// console.log(e.target);
				let parentListItem = e.target.parentElement;

				if (
					document.querySelector(".item-active") &&
					document.querySelector(".item-active") !== parentListItem
				) {
					document.querySelector(".item-active").classList.remove("item-active");
				}
			});
		});

		this.modalTriggerElements.forEach((trigger) => {
			const triggerID = trigger.getAttribute("data-bm-trigger");
			let modalEl = null;
			let validTrigger = false;

			// Trigger Safety checks
			// Check for a valid id on trigger
			this.modals.forEach((modal) => {
				if (modal.id === triggerID) {
					validTrigger = true;
					modalEl = modal;
				}
			});

			// Throw message if valid trigger not found
			if (!validTrigger) {
				throw {
					message:
						"Better Modal has found a trigger that does not have a valid ID: Check the ID for this trigger",
					el: trigger,
				};
			}
			// End trigger safety checks

			// add hover listener
			trigger.addEventListener("mouseenter", (e) => {
				// console.log(trigger.parentElement.id);
				// modalEl.dispatchEvent(this.events["bm-open"]);

				let parentListItem = e.target.parentElement;
				parentListItem.classList.add("item-active");

				this.events["bm-close"](modalEl, trigger.parentElement.id);
				this.events["bm-open"](modalEl, trigger.parentElement.id);
			});
		});

		// check whether there the menu items should have a hover event to cancel menu
	}

	openModalEvent(event) {
		const modal = event.target;
		const modalCard = modal.querySelector("[data-bm-card]");
		const modalOverlay = modal.querySelector("[data-bm-overlay]");
		const button = document.querySelector(`[data-bm-button="${modal.id}"]`);
		const modalButton = modalCard.querySelector("[data-bm-button]");

		modal.setAttribute("data-bm-is-open", "");
		modalCard.setAttribute("data-bm-active", "");
		modalOverlay.setAttribute("data-bm-active", "");

		if (modal.hasAttribute("data-bm-is-offcanvas")) {
			offCanvasOpen(modalCard, modal.getAttribute("data-bm-position"));
			this.body.setAttribute("data-bm-offcanvas", modal.getAttribute("data-bm-position"));
		}

		this.body.style.overflowY = "hidden";
	}

	closeModalEvent(event) {
		const modal = event.target;
		const modalCard = modal.querySelector("[data-bm-card]");
		const modalOverlay = modal.querySelector("[data-bm-overlay]");
		const button = document.querySelector(`[data-bm-button]`);

		modal.removeAttribute("data-bm-is-open");
		modalCard.removeAttribute("data-bm-active");
		modalOverlay.removeAttribute("data-bm-active");

		if (modal.hasAttribute("data-bm-is-offcanvas")) {
			offCanvasClose(modalCard, modal.getAttribute("data-bm-position"));
		}

		// For accessibility return focus to the button that was clicked
		button.focus({
			preventScroll: true,
		});

		this.body.style.overflowY = "auto";
	}
	// Add aria label navigation button

	// add aria controls for id#

	// data-bm-is-open

	// data-bm-animation

	registerModalEvent(modal, eventName, event) {
		const modalID = modal.id;

		const addEventListener = () => {
			modal.addEventListener(eventName, event);
		};

		const removeEventListener = () => {
			modal.removeEventListener(eventName, event);
		};

		// Initialize the listener
		addEventListener();

		if (!this.modalEvents[modalID]) {
			this.modalEvents[modalID] = [];
		}

		this.modalEvents[modalID].push({
			eventName: eventName,
			addEventListener: addEventListener,
			removeEventListener: removeEventListener,
			listenerActive: true,
		});
	}

	pauseModalEvent(modal, eventName) {
		const eventObj = this.modalEvents[modal.id].filter((eventObj) => {
			if (eventObj.eventName === eventName) {
				return true;
			}
		});

		eventObj.removeEventListener();
	}

	resumeModalEvent(modal, eventName) {
		const eventObj = this.modalEvents[modal.id].filter((eventObj) => {
			if (eventObj.eventName === eventName) {
				return true;
			}
		});

		eventObj.removeEventListener();
	}

	addModalOverlay(modal) {
		const overlay = document.createElement("div");
		overlay.setAttribute("data-bm-overlay", modal.id);
		modal.appendChild(overlay);

		overlay.addEventListener("click", (event) => {
			const modal = event.target.closest("[data-better-modal]");
			modal.dispatchEvent(this.events["bm-close"]);
		});
	}
}

export default BetterModal;
